export default __webpack_public_path__ + "static/media/codigoEtica.a27468e5.jpg";